import React from "react";
import { FormField } from "./FormField";

const MESSAGE_ROWS = 5;

export const QuoteFields = ({ t, form, onChange }) => (
  <>
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
      <FormField id="name" label={t.contact.nameLabel} required>
        <input id="name" name="name" type="text" required value={form.name} onChange={onChange}
          placeholder={t.contact.namePh} data-testid="input-name" className="brand-input" />
      </FormField>
      <FormField id="phone" label={t.contact.phoneLabelForm} required>
        <input id="phone" name="phone" type="tel" required value={form.phone} onChange={onChange}
          placeholder={t.contact.phonePh} data-testid="input-phone" className="brand-input" />
      </FormField>
    </div>

    <FormField id="service" label={t.contact.serviceLabel}>
      <select id="service" name="service" value={form.service} onChange={onChange}
        data-testid="input-service" className="brand-input bg-white">
        <option value="">—</option>
        {t.services.items.map((s) => (
          <option key={s.name} value={s.name}>{s.name}</option>
        ))}
      </select>
    </FormField>

    <FormField id="message" label={t.contact.messageLabel}>
      <textarea id="message" name="message" rows={MESSAGE_ROWS} value={form.message} onChange={onChange}
        placeholder={t.contact.messagePh} data-testid="input-message" className="brand-input resize-none" />
    </FormField>
  </>
);
